<template>
  <div class="invoice">
    <Nav :title="title" :back="back"></Nav>
    <div class="content" :class="{ isIosx: isiOSX }">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="clickMore(index)"
      >
        <p class="left">{{ item.title }}</p>
        <img src="./../../assets/takingCar/moreright.png" alt class="right" />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "开具发票",
      list: [{ title: "按行程开票" }, { title: "开票历史" }],
      isiOSX: false,
      back: 0,
    };
  },
  components: { Nav },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
      this.back = 1
    }else {
      this.back = 0
    }
  },
  methods: {
    clickMore(index) {
      if (index == 0) {
        //   按行程开发票
        this.$router.push({
          path: "/takingCar/journeyInvoice",
        });
      } else {
        //   开票历史
        this.$router.push({
          path: "/takingCar/invoiceHistory",
        });
      }
    },
  },
};
</script>

<style lang="less">
.invoice {
  background: #ffffff;
  height: 100%;
  .content {
    padding-top: 70px;
    margin: 0 15px;
    .item:nth-child(1) {
      border-bottom: 1px solid #dddddd;
    }
    .item {
      overflow: hidden;
      color: #333333;
      font-size: 15px;
      line-height: 21px;
      height: 21px;
      padding: 15px 0;
      .left {
        float: left;
      }
      .right {
        float: right;
        width: 12px;
        margin-top: 4.5px;
      }
    }
  }
  .isIosx {
    padding-top: 90px;
  }
}
</style>
